import { Component, Input, OnInit, ProviderToken } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TRANSLATION_SCOPE, translationProvider } from './i18n/translation.provider';
import {
  DefaultFormValue,
  ErrorMessagesService,
  ErrorMessagesServiceBase,
  FormElement,
  FormHelperService,
  FormServicesInjectionToken,
  FormTemplateInterface,
} from '@rx-applications/shared/utils-forms';
import { RoomsFormTemplates } from '../enums/rooms-form-templates.enum';
import { RoomsFormTemplateService } from '../services/form/rooms-form-template.service';
import { AsPipeModule } from '@rx-applications/shared/utils';
import { ReactiveFormsModule } from '@angular/forms';
import { ClientsiteCheckoutRoomComponent } from '../components/clientsite-checkout-room/clientsite-checkout-room.component';
import { RoomFormTemplateService } from '../services/form/room-form-template.service';
import { Room } from '@rx-applications/clientsite/shared/utils';
import { TranslocoDirective } from '@ngneat/transloco';
import { map, Observable } from 'rxjs';
import { SearchGuest, LoyaltyCardForm } from '@rx-applications/clientsite-guestbook/api';
import { RxAlertModule } from '@roomex/rx-components';

@Component({
  selector: 'rx-applications-clientsite-checkout-feature-rooms',
  standalone: true,
  imports: [
    CommonModule,
    AsPipeModule,
    ReactiveFormsModule,
    ClientsiteCheckoutRoomComponent,
    TranslocoDirective,
    RxAlertModule,
  ],
  templateUrl: './clientsite-checkout-feature-rooms.component.html',
  styleUrls: ['./clientsite-checkout-feature-rooms.component.scss'],
  providers: [
    translationProvider,
    {
      provide: FormServicesInjectionToken,
      useValue: new Map<RoomsFormTemplates, ProviderToken<FormTemplateInterface<DefaultFormValue>>>([
        [RoomsFormTemplates.ROOMS, RoomsFormTemplateService],
        [RoomsFormTemplates.ROOM, RoomFormTemplateService],
      ]),
    },
    {
      provide: ErrorMessagesServiceBase,
      useClass: ErrorMessagesService,
    },
    FormHelperService,
  ],
})
export class ClientsiteCheckoutFeatureRoomsComponent extends FormElement implements OnInit {
  @Input() rooms: Room[];

  TRANSLATION_SCOPE = TRANSLATION_SCOPE;

  showLoyaltyAlert$: Observable<boolean>;

  constructor() {
    super();
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.add(RoomsFormTemplates.ROOMS);
    this.initializeShowLoyaltyAlertObservable();
  }

  private initializeShowLoyaltyAlertObservable(): void {
    this.showLoyaltyAlert$ = this.form
      .get(this.formSectionName)
      .valueChanges.pipe(
        map((rooms) =>
          rooms.some(({ guests }) =>
            guests.some(
              (guest: SearchGuest) =>
                (guest.loyaltyCard as LoyaltyCardForm)?.confirmed && guest.loyaltyCard?.loyaltyProgramId
            )
          )
        )
      );
  }
}
